import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.less';
import 'src/assets/less/index.less';
import App from './App';
import { storeConfig } from './configs/store.config';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

let persistor = persistStore(storeConfig);
ReactDOM.render(
  <Provider store={storeConfig}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
